export default __webpack_public_path__ + "770e14d74804a61c0acbb82b33803112.png";